import React from 'react';
import envConfig from '../../config/env';
//import pictureList from './managerPicturesList';

class managerPicturesCenter extends React.Component{

    constructor(props) {
        super(props);
        this.state = { menu: [],subMenu:[],imageData:[],showSubMenu:[],showImage:[],value:'',value2:'',text1:'',text2:'',subMenuShow:false,previewShowPicture:'' };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeSub = this.handleChangeSub.bind(this);
        
      }

      
      componentDidMount() {  
              
            fetch(`${envConfig.ImageDataAPI}data/1111_MenuImageData.json`  
            ,{  headers : { 'Content-Type': 'application/json','Accept': 'application/json' }     }
            ).then(function(response){
                //console.log(response)
                return response.json();
              })
              .then(myJson=> {
                //console.log('getMenu1111Data:'+myJson.menu);
                  if(myJson!=null && typeof(myJson)!='undefined'){
                    this.setState({ ...this.state ,menu:myJson.menu ,subMenu: myJson.subMenu,imageData:myJson.imageData});
                 }
              });  
              
      }
     //主選單事件
      handleChange(event){
        //選擇的value
        //console.log(event.target[event.target.selectedIndex].text)
        let selectValue = event.target.value;
        let selectText = event.target[event.target.selectedIndex].text;
        let dataset=event.target.options[event.target.selectedIndex].dataset;
        let subMenu=dataset.sub;
        let subMenuCheck=false;
        //篩選資料
        let resultSubMenu=this.state.subMenu.filter(x=>x.id===subMenu);
        let finalDataSubMenu=[];      
        if(resultSubMenu.length>0){
          subMenuCheck=true;
          resultSubMenu.forEach(x=>{finalDataSubMenu=finalDataSubMenu.concat(x.subData) }  );
          //console.log('finalDataSubMenu:'+finalDataSubMenu)  
        }
        let resultImageData=this.state.imageData.filter(x=>x.id===selectValue);
        let finalData=[];      
        if(resultImageData.length>0){
            //合併資料
            resultImageData.forEach(x=>{finalData=finalData.concat(x.imageData) }  );    
            //console.log('finalData:'+finalData)              
        }
        
        //顯示改變
        this.setState({ ...this.state,value:selectValue,text1:selectText,value2:'',text2:'',subMenuShow:subMenuCheck,showSubMenu: finalDataSubMenu,showImage:finalData});
      }
      //子選單事件
      handleChangeSub(event){
        let selectSubValue = event.target.value;
        let selectSubText = event.target[event.target.selectedIndex].text;
        //console.log('id:'+this.state.value+' ,sid:'+selectSubValue); 
        let resultImageData=this.state.imageData.filter(x=>x.id===this.state.value && x.sid===selectSubValue);
        if(resultImageData.length<=0)
        {
          resultImageData=this.state.imageData.filter(x=>x.id===this.state.value);
        }
        let finalData=[];
        if(resultImageData.length>0){
          resultImageData.forEach(x=>{finalData=finalData.concat(x.imageData) }  );   
          //console.log('handleChangeSub-finalData:'+finalData) 
        }
        this.setState({ ...this.state,value2:selectSubValue,text2:selectSubText,showImage:finalData});
      }
      handlePreviewClick(x){
        //console.log('handlePreviewClick'+x)
        this.setState({ ...this.state,previewShowPicture:x});
      }
      render() {
        return(
            <div className="container-fluid">
                <div className="form-row">
                   <div className="col-md-3 mb-3">
                     <div className="form-row mangerweb-pb-1">                       
                            <select  className="form-control" id="pictureMenu" onChange={this.handleChange} value={this.state.value} >
                                <option value='' data-sub="">選擇圖片分類...</option>
                                {
                                    this.state.menu && this.state.menu.length>0 && this.state.menu.map((item)=><option key={item.id} value={item.id} data-sub={item.extend}>{item.text}</option>)
                                }
                            </select>
                     </div>
                   </div>  
                   <div className="col-md-3 mb-3" style={this.state.subMenuShow ? {} :{ display:'none'}}>
                     <div className="form-row mangerweb-pb-1"> 
                         <select  className="form-control" id="pictureSubMenu" onChange={this.handleChangeSub} value={this.state.value2} >
                            <option value='' data-sub="">選擇圖片子分類...</option>
                            { 
                               this.state.showSubMenu && this.state.showSubMenu.length>0 && this.state.showSubMenu.map(item=><option key={item.sid} value={item.sid} >{item.text}</option>)
                            }
                         </select>
                     </div> 
                    </div>                                
                </div>
                <div className="form-row pictures_pt">
                  <div className="col-12 ">
                      <h1 className="font-weight-bold text-black">{this.state.text1}{this.state.text2===""?"":" - "+this.state.text2}</h1>
                  </div>
                 </div>
                <div className="form-row pictures_pt">
                    { this.state.showImage && this.state.showImage.length>0 && this.state.showImage.map( (element,index)=> { 
                          //  console.log(element)
                          return (      
                            <div className="col-md-2 mb-6" key={index}>
                            <img src={`/image/small/${element}`} alt="pictures" width="90%"/><br />   
                            <a type="button" data-toggle="modal" href="#pictures_Pre" onClick={()=>this.handlePreviewClick(element)}>觀看放大圖例</a><br />                                                 
                            <a download href={`/image/pictures2/${element}`}>下載圖片</a>
                            </div> 
                            )   
                         }                 
                      )                
                    }
               </div>
               <div className="modal fade" id="pictures_Pre">
                <div className="modal-dialog sample-img-width">
                    <div className="modal-content">
                        <div className="modal-header">
                            <p className="modal-title">圖片預覽</p>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body text-center">
                            <a download href={`/image/pictures2/${this.state.previewShowPicture}`}>下載圖片</a>
                            <img src={`/image/pictures2/${this.state.previewShowPicture}`} alt="pictures_Pre" width="100%" />
                        </div>
                        <div className="modal-footer">
                            <p className="small">可作為版型圖片使用</p>
                        </div>
                    </div>
                </div>
            </div>  
            </div>                
        )
      }
}

export default managerPicturesCenter;